import React from "react";
import { useRouter } from "next/router";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import Rate from "components/Pages/Rate/index.tsx";
import { get_tdk } from "api/server/tdk";
import { Platform, Util, Hooks } from "@xt/xtbase";
const { getOrigin } = Util;
const { useTranslation } = Hooks;

export default function PageRate(props) {
  const isInApp = Platform.isInApp();
  const t = useTranslation();
  const router = useRouter();

  const handleBack = () => router.back();

  return (
    <>
      {isInApp ? (
        <Rate />
      ) : (
        <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
          <BackHeader title={t("rate.title") || "Rate"} onBack={handleBack} />
          <div style={{ paddingTop: "calc(44px + env(safe-area-inset-top, 0px))" }}>
            <Rate />
          </div>
        </Layout>
      )}
    </>
  );
}
export async function getStaticProps(context) {
  const resolvedUrl = "/rate";
  const props = { resolvedUrl };
  try {
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType:
          context.locale == "zh-CN"
            ? "cn"
            : context.locale == "zh-HK"
            ? "hk"
            : context.locale,
      },
    });
    props.tdk = tdk || {};
  } catch (error) {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }

  return {
    props,
    revalidate: 60,
  };
}
